module.exports = __webpack_public_path__ + "static/img/bg1.ad1a62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/DiscountAgentInvite/H5/bg1.png
// module id = 0FEx
// module chunks = 69